import axios from "axios"

export default function getLoyaltyPoint({ id }) {
    return new Promise((resolve, reject) => {
        axios.get(`/campaign/api/admin/campaigns/${id}`)
            .then(response => resolve(response.data))
            .catch(error => reject(error.response.data))
    })
}